export const Colors = {
  // Primary colors
  primary: '#28BD97',
  primaryDark: '#20a085',
  primaryLight: '#e8f5f1',
  
  // Text colors
  textPrimary: '#1a1a1a',
  textSecondary: '#6c757d',
  textMuted: '#9ca3af',
  textOnPrimary: '#ffffff',
  
  // Background colors
  background: '#ffffff',
  backgroundSecondary: '#f8f9fa',
  
  // Status colors
  success: '#28a745',
  warning: '#ffc107',
  error: '#dc3545',
  info: '#17a2b8',
  
  // Border colors
  border: '#e9ecef',
  borderLight: '#f1f3f4',
  
  // Other colors
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
  
  // Additional colors
  hoverBackground: 'rgba(40, 189, 151, 0.1)',
  activeBackground: 'rgba(40, 189, 151, 0.15)',
  inputBackground: '#f8f9fa',
} as const;

export type ColorKey = keyof typeof Colors;
